import { Button as c } from "./index82.mjs";
import e from "react";
import t from "./index237.mjs";
import { formatPrice as d } from "./index110.mjs";
const _ = ({ giftCard: i, currency: r, onSelect: a }) => {
  const { name: n, amount: l, validity_period: s } = i;
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: t["gift-card-tile"],
      "data-testid": "gift-card-tile",
      onClick: a
    },
    /* @__PURE__ */ e.createElement("div", { className: t.container }, /* @__PURE__ */ e.createElement("div", { className: t["image-container"] }, /* @__PURE__ */ e.createElement("img", { src: i.image, "data-testid": "gift-card-image" })), /* @__PURE__ */ e.createElement("div", { className: t.container_mobile }, /* @__PURE__ */ e.createElement("div", { className: t.content }, /* @__PURE__ */ e.createElement("div", { className: t.name, "data-testid": "gift-card-name" }, n), /* @__PURE__ */ e.createElement("div", { className: t.price, "data-testid": "gift-card-price" }, d(parseFloat(l), r)), /* @__PURE__ */ e.createElement(
      "div",
      {
        className: t.validity_period,
        "data-testid": "gift-card-validity-period"
      },
      I18n.t("booking_engine.gift_cards.validity_period", {
        count: s.toString()
      })
    )), /* @__PURE__ */ e.createElement("div", { className: t.button_container_mobile }, /* @__PURE__ */ e.createElement(
      c,
      {
        label: I18n.t("booking_engine.search.select"),
        dataTestId: "gift-card-select",
        classes: t.gift_card_button,
        onClick: a
      }
    )))),
    /* @__PURE__ */ e.createElement("div", { className: t.button_container }, /* @__PURE__ */ e.createElement(
      c,
      {
        label: I18n.t("booking_engine.search.select"),
        dataTestId: "gift-card-select",
        classes: t.gift_card_button,
        onClick: a
      }
    ))
  );
};
export {
  _ as GiftCardTile
};
